import { ShieldCheck } from 'lucide-react';
import * as React from 'react';

// =============================================================================
// confidentiality-banner.tsx — Bannière de cloisonnement / anonymat (DS « banner-cloison »).
// =============================================================================
// Restitue, de façon VISIBLE, le message de cloisonnement / confidentialité déjà porté par
// l'écran (K-anonymity, séparation des mondes DBU). Accent teal (--chart-2, couleur du portail
// fournisseur) — JAMAIS un code métier `--metier-*`. Icône bouclier décorative (aria-hidden) ;
// l'information vit intégralement dans le texte (`children`), la couleur n'en est que le renfort
// (WCAG 2.1 AA : jamais l'information par la seule couleur). Composant PUR de présentation.

export interface ConfidentialityBannerProps {
  /** Texte porteur du message de cloisonnement / confidentialité (autorité a11y). */
  readonly children: React.ReactNode;
}

export function ConfidentialityBanner({
  children,
}: ConfidentialityBannerProps): React.JSX.Element {
  return (
    <div className="flex gap-3 rounded-md border border-chart-2/30 bg-chart-2/10 px-4 py-3 text-sm">
      <span
        aria-hidden="true"
        className="flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-chart-2/15 text-chart-2"
      >
        <ShieldCheck className="h-4 w-4" />
      </span>
      <div className="min-w-0 leading-relaxed text-muted-foreground">{children}</div>
    </div>
  );
}
